import request from '@/utils/request'

/**
 * @description 上传
 * @param {Object} param data {Object} 传值参数
 */
export function getOssConfig (configId) {
  return request({
    url: '/common/get-oss-signature',
    method: 'get'
  })
}

/**
 * Multipart 文件上传，后端返回完整访问 URL（CommonResponse.data 为字符串）
 * @param {File} file 原始文件对象
 */
export function uploadGFile (file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/common/g-file-upload',
    method: 'post',
    data: formData,
    headers: {
      repeatSubmit: false
    },
    transformRequest: [(data, headers) => {
      if (data instanceof FormData) {
        delete headers['Content-Type']
      }
      return data
    }]
  })
}
